import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

export const getTicketByCode = async (ticketCode) => {
  setBackendDomain(jwtAuthAxios);
  const safeCode = encodeURIComponent(String(ticketCode || ""));
  const { data } = await jwtAuthAxios.get(
    `/api/v1/access-system/tickets/by-code/${safeCode}`
  );
  return data;
};

export const getTicketById = async (ticketId) => {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(String(ticketId || ""));
  const { data } = await jwtAuthAxios.get(
    `/api/v1/access-system/tickets/${safeId}`
  );
  return data;
};

export const getAllTickets = async ({ limit = 20, offset = 0 } = {}) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/api/v1/access-system/tickets/all`,
    { params: { limit, offset } }
  );
  return data;
};

export const searchTickets = async ({ q, limit } = {}) => {
  setBackendDomain(jwtAuthAxios);
  const params = { q: String(q ?? "").trim() };
  if (typeof limit === "number" && limit > 0) {
    params.limit = limit;
  }
  const { data } = await jwtAuthAxios.get(
    `/api/v1/access-system/tickets/search`,
    { params }
  );
  return data;
};

export const reprintTicket = async (ticketId) => {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(String(ticketId || ""));
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/tickets/${safeId}/reprint`
  );
  return data;
};

